module.exports = require(`./1.1.0/index.vue`);
